import _ from "lodash";
import { getWizard } from "../../../store/root.selectors";

export const getProfiles = _.flow([getWizard, ({ profiles }) => profiles]);
export const isSavedProfiles = (state) => !_.isEmpty(getProfiles(state).list);
